// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectSubscribeResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_SUBSCRIBE_RESPONSE_MESSAGE);
        this.InstrumentId = null;
        this.Route = null;
        this.CanGetSnapshot = false; // #100287
        this.Delay = 0;
        this.IsDataSource = false; // #101396
        // #49909
        // уникальный идентификатор SubcribeMessage в котором была отправлена группа,
        // на основании которой был сгенерирован этот мессадж
        this.RequestID = 0;
        // #49909
        // уникальный идентификатор группы в SubcribeMessage на основании которой
        // был сгенерирован этот мессадж, т.е. по RequestID мы находим сам мессадж,
        // по GroupID - группу
        // и уже по этой группе находим инструмент и подписку
        this.GroupID = -1;
        // #49909
        // здесь возвращается битовый флаг подписки,
        // например мы отправили 3 - это значит мы подписываемся на quote1 и quote2 (1+2=3)
        // в ответ нам пришел флаг 1 - значит мы удачно подписались только на quote1
        // 0 - подписка не произошла
        // может принимать значения 0 1 2 4 8  (4 - трейды, 8 - опционы?)
        this.Service = 0;
        // #49909
        // Если пришел ErrorCode, значит подписка прошла неудачно
        this.ErrorCode = null;
    }
}
